import React, { createContext, useCallback, useContext, useState } from "react"

const isMiniPlayerEnabledContext = createContext(true)
const setIsMiniPlayerEnabledContext = createContext({
  active: () => {},
  inactive: () => {}
})
const contentTypeContext = createContext<ContentType>('main')
const setContentTypeContext = createContext({
  setContentType: (type: ContentType) => {}

})

interface Props {
  children?: React.ReactNode
}
export type ContentType = 'main' | 'chart' | 'youtube'

export const ContentType = {
  main: 'main',
  chart: 'chart',
  youtube: 'youtube'

} as const


export function MiniPlayerEnabledProvider({ children }: Props) {
  const [isEnabled, setIsEnabled] = useState<boolean>(false) // TODO : change to false
  const [contentType, setContentType] = useState<ContentType>('main')
  const active = useCallback(() => {
    setIsEnabled(true)
  }, [])

  const inactive = useCallback(() => {
    setIsEnabled(false)
  }, [])

  return (
    <isMiniPlayerEnabledContext.Provider value={isEnabled}>
      <setIsMiniPlayerEnabledContext.Provider value={{ active, inactive }}>
        <contentTypeContext.Provider value={contentType}>
          <setContentTypeContext.Provider value={{ setContentType }}>
            {children}
          </setContentTypeContext.Provider>
        </contentTypeContext.Provider>
      </setIsMiniPlayerEnabledContext.Provider>
    </isMiniPlayerEnabledContext.Provider>
  )
}

export function useIsMiniPlayerEnabled() {
  return useContext(isMiniPlayerEnabledContext)
}

export function useSetIsMiniPlayerEnabled() {
  return useContext(setIsMiniPlayerEnabledContext)
}

export function useContentType() {
  return useContext(contentTypeContext)
}

export function useSetContentType() {
  return useContext(setContentTypeContext)
}